import { Row } from '@tanstack/react-table';
import { FC } from 'react';

import { Audience } from '@/models/audiences';

type AudienceNameColumnProps = {
  row: Row<Audience>;
};

export const AudienceNameColumn: FC<AudienceNameColumnProps> = ({ row }) => {
  return (
    <div className='flex items-center gap-3 ps-px'>
      <p>{row.original.name}</p>
    </div>
  );
};
